import { ScreenCaptureService } from '@mpt-fo/common/core/services/screen-capture.service';
import { Component, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { logger } from '@mpt-fo/common/telemetry';
import * as faceapi from 'face-api.js';

@Component({
	selector: 'app-face-capture',
	templateUrl: './face-capture.component.html',
	styleUrls: ['./face-capture.component.scss']
})
export class FaceCaptureComponent implements OnInit, OnDestroy {

	@Input() error: string;
	@Input() submitting: boolean;
	@Input() numberOfImages = 2;
	@Input() confidenceScore = 0.8;
	@Output() continue: EventEmitter<any> = new EventEmitter();
	@Output() back: EventEmitter<any> = new EventEmitter();
	video: HTMLVideoElement;
	container: HTMLElement;
	dataURI: string;
	context: void;
	images = [];
	detections: faceapi.FaceDetection[];
	loadingModels: boolean;
	convertedImages = [];
	stream: MediaStream;


	constructor(
		private captureService: ScreenCaptureService
	) {
	}

	ngOnInit(): void {
		this.video = document.getElementById('video') as HTMLVideoElement;
		this.video.setAttribute('autoplay', '');
		this.video.setAttribute('muted', '');
		this.video.setAttribute('playsinline', '');
		this.container = document.getElementById('face-capture-container');
		this.loadModels();
	}

	loadModels() {
		this.loadingModels = true;
		Promise.all([
			faceapi.nets.tinyFaceDetector.loadFromUri('assets/face-api-models'),
		]).then(vid => {
			this.startVideo(this.video);
		}).catch(err => {
			console.log('err from face thing: ', err);
		});
	}

	submit() {
		this.convertImagesToFile();
		this.continue.emit(this.convertedImages);
	}

	startVideo(vid) {
		navigator.mediaDevices.getUserMedia({ video: {} }).then(stream => {
			vid.srcObject = stream;
			this.stream = stream;
			vid.onloadedmetadata = (e) => {
				this.setListener();
				this.loadingModels = false;
			};
		}).catch(err => {
			logger.error(err);
		});
	}

	setListener() {
		this.video.addEventListener('play', () => {
			const canvas = faceapi.createCanvasFromMedia(this.video);
			canvas.className = 'face-canvas';
			this.container.append(canvas);
			const displaySize = { width: this.video.width, height: this.video.height };
			faceapi.matchDimensions(canvas, displaySize);
			setInterval(async () => {
				this.detections = await faceapi.detectAllFaces(this.video, new faceapi.TinyFaceDetectorOptions());
				const resizedDetections = faceapi.resizeResults(this.detections, displaySize);
				const canvasContext = canvas.getContext('2d');
				canvasContext.clearRect(0, 0, canvas.width, canvas.height);
				faceapi.draw.drawDetections(canvas, resizedDetections);
			}, 1000);
		});
	}

	snap() {
		if (this.images.length >= this.numberOfImages) { return; }
		if (this.detections && this.detections[0].score >= this.confidenceScore) {
			const canvasImg = document.getElementsByClassName('face-canvas')[0] as HTMLCanvasElement;
			canvasImg.getContext('2d').drawImage(this.video, 0, 0, this.video.width, this.video.height);
			const dataUrl = canvasImg.toDataURL('image/jpeg');
			this.images.push(dataUrl);
		}
	}

	convertImagesToFile() {
		for (let i = 0; i < this.images.length; i++) {
			this.convertedImages.push(this.captureService.base64ToFile(this.images[i], `image${i}.jpg`));
		}
	}

	removePhoto(photo) {
		const index = this.images.findIndex(x => photo === x);
		this.images.splice(index, 1);
	}

	ngOnDestroy(): void {
		removeEventListener('play', () => {
			const canvas = faceapi.createCanvasFromMedia(this.video);
			canvas.className = 'face-canvas';
			canvas.id = 'canvas-id';
			this.container.append(canvas);
			const displaySize = { width: this.video.width, height: this.video.height };
			faceapi.matchDimensions(canvas, displaySize);
			setInterval(async () => {
				const detections = await faceapi.detectAllFaces(this.video, new faceapi.TinyFaceDetectorOptions());
				const resizedDetections = faceapi.resizeResults(detections, displaySize);
				canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
				faceapi.draw.drawDetections(canvas, resizedDetections);
			}, 100);
		});
		this.stopVideo();
	}

	stopVideo() {
		this.stream.getTracks()[0].stop();
	}

}
